const PLUGIN_NAME = 'boat-content';

export { PLUGIN_NAME };
